import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThLarge, faBullseye, faDotCircle, faFlagCheckered, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/logo.png';

const SidebarContainer = styled.div`
  grid-area: 2 / 1 / 7 / 2;
  background: var(--sidebar-bg);
  border-right: 1px solid var(--border-dark);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SidebarItem = styled.div.withConfig({ shouldForwardProp: (prop) => prop !== 'yellow' && prop !== 'selected' })<{ selected?: boolean; yellow?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  width: 100%;
  color: ${props => props.yellow ? 'rgb(212, 162, 0)' : 'var(--border-light)'};
  cursor: pointer;
  margin-bottom: 8px;
  border-left: 3px solid transparent;
  position: relative;

  ${props => props.selected && `
    background: rgba(255, 184, 0, 0.15);
    border-left-color: var(--yellow);
  `}

  &:hover {
    opacity: 0.7;
  }
`;

const Icon = styled.div`
  font-size: 20px;
  margin-bottom: 6px;
`;

const Label = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: bold;

  ${SidebarItem}.selected & {
    color: var(--text-white);
  }
`;

const Label2 = styled.div`
  background-color: var(--yellow);
  color: var(--sidebar-bg);
  font-size: 12px;
  font-family: inherit;
  padding: 4px 8px;
  margin-top: 10px;
`;

const Label3 = styled.div`
  background-color: rgba(52, 59, 87, 0.5);
  color: #7487d3;
  font-size: 12px;
  font-family: inherit;
  padding: 4px 15px;
  margin-top: 10px;
`;

const Tag = styled.div`
  background-color: rgb(255, 44, 44);
  color: white;
  font-size: 10px;
  position: absolute;
  left: 50px;
  padding: 1px;
`;

const LogoImg = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
  margin-bottom: 8px;
`;

const Sidebar = () => {
  return (
    <SidebarContainer>
      <SidebarItem selected>
        <LogoImg src={logo} alt="Home" />
        <Label>Home</Label>
      </SidebarItem>

      <SidebarItem>
        <Icon><FontAwesomeIcon icon={faThLarge} /></Icon>
        <Label>Main</Label>
      </SidebarItem>

      <SidebarItem>
        <Icon><FontAwesomeIcon icon={faBullseye} /></Icon>
        <Label>Jackpot</Label>
        <Label3><span>$ 5 6</span></Label3>
      </SidebarItem>

      <SidebarItem yellow={true}>
        <Icon><FontAwesomeIcon icon={faDotCircle} /></Icon>
        <Label>Coin Flip</Label>
        <Label2>$ 5678</Label2>
      </SidebarItem>

      <SidebarItem>
        <Icon><FontAwesomeIcon icon={faFlagCheckered} /></Icon>
        <Label>Race</Label>
      </SidebarItem>

      <SidebarItem>
        <Icon><FontAwesomeIcon icon={faArrowUp} /></Icon>
        <Label>Upgrade</Label>
        <Tag>NEW</Tag>
      </SidebarItem>
    </SidebarContainer>
  );
};

export default Sidebar; 